const Phone = () => (
    <svg width="67" height="67" viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_352_13926)">
            <path
                d="M46.9496 6.21436H19.3297C17.8043 6.21436 16.5677 7.45094 16.5677 8.97634V57.3111C16.5677 58.8365 17.8043 60.0731 19.3297 60.0731H46.9496C48.475 60.0731 49.7116 58.8365 49.7116 57.3111V8.97634C49.7116 7.45094 48.475 6.21436 46.9496 6.21436Z"
                stroke="#343434"
                strokeWidth="2.76199"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M28.9967 12.429L37.2827 12.429" stroke="#343434" strokeWidth="2.76199" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M36.2469 52.8231C36.2469 54.5391 34.8557 55.9303 33.1396 55.9303C31.4236 55.9303 30.0324 54.5391 30.0324 52.8231C30.0324 51.107 31.4236 49.7158 33.1396 49.7158C34.8557 49.7158 36.2469 51.107 36.2469 52.8231Z"
                fill="#343434"
            />
        </g>
        <defs>
            <clipPath id="clip0_352_13926">
                <rect width="66.2876" height="66.2876" fill="white" transform="translate(-0.00415039)" />
            </clipPath>
        </defs>
    </svg>
);

const Camera = () => (
    <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_352_13966)">
            <path
                d="M11.55 54.6001C9.8103 54.6001 8.39999 53.1898 8.39999 51.4501V22.7501C8.39999 21.0104 9.8103 19.6001 11.55 19.6001H22.1454L26.1055 13.55C26.4935 12.9573 27.1542 12.6001 27.8626 12.6001H39.3374C40.0458 12.6001 40.7065 12.9573 41.0945 13.55L45.0545 19.6001H55.65C57.3897 19.6001 58.8 21.0104 58.8 22.7501V51.4501C58.8 53.1898 57.3897 54.6001 55.65 54.6001H11.55Z"
                stroke="#343434"
                strokeWidth="3.15"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="50.4" cy="27.3" r="2.1" fill="#343434" />
            <path
                d="M33.6 46.2C39.3992 46.2 44.1 41.4991 44.1 35.7C44.1 29.9008 39.3992 25.2 33.6 25.2C27.8009 25.2 23.1 29.9008 23.1 35.7C23.1 41.4991 27.8009 46.2 33.6 46.2Z"
                stroke="#343434"
                strokeWidth="3.15"
                strokeMiterlimit="10"
            />
        </g>
        <defs>
            <clipPath id="clip0_352_13966">
                <rect width="67.2" height="67.2" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const Drone = () => (
    <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_353_13986)">
            <path
                d="M19.0954 19.0952L27.6439 27.6437M48.4046 48.4044L39.8561 39.8559"
                stroke="#343434"
                strokeWidth="3.267"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M48.4046 19.0952L39.8561 27.6437M19.0954 48.4044L27.6439 39.8559"
                stroke="#343434"
                strokeWidth="3.267"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M39.8561 27.644H27.6439V39.8562H39.8561V27.644Z" stroke="#343434" strokeWidth="3.267" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M48.4046 27.6441C50.0954 27.6441 51.748 27.1428 53.1539 26.2035C54.5596 25.2641 55.6553 23.9291 56.3024 22.367C56.9494 20.805 57.1187 19.0861 56.7889 17.4279C56.459 15.7696 55.6448 14.2465 54.4492 13.0509C53.2538 11.8554 51.7306 11.0412 50.0723 10.7114C48.4141 10.3815 46.6953 10.5508 45.1332 11.1978C43.5711 11.8449 42.2361 12.9405 41.2967 14.3463C40.3574 15.7521 39.8561 17.4049 39.8561 19.0956"
                stroke="#343434"
                strokeWidth="3.267"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M48.4046 39.856C50.0954 39.856 51.748 40.3573 53.1539 41.2966C54.5596 42.236 55.6553 43.571 56.3024 45.1331C56.9494 46.6951 57.1187 48.414 56.7889 50.0722C56.459 51.7305 55.6448 53.2537 54.4492 54.4491C53.2538 55.6447 51.7306 56.4589 50.0723 56.7887C48.4141 57.1186 46.6953 56.9493 45.1332 56.3023C43.5711 55.6552 42.2361 54.5595 41.2967 53.1538C40.3574 51.7479 39.8561 50.0952 39.8561 48.4045"
                stroke="#343434"
                strokeWidth="3.267"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.0954 39.856C17.4046 39.856 15.7519 40.3573 14.3461 41.2966C12.9403 42.236 11.8446 43.571 11.1976 45.1331C10.5506 46.6951 10.3813 48.414 10.7112 50.0722C11.041 51.7305 11.8552 53.2537 13.0507 54.4491C14.2462 55.6447 15.7694 56.4589 17.4277 56.7887C19.0859 57.1186 20.8048 56.9493 22.3668 56.3023C23.9289 55.6552 25.2639 54.5595 26.2033 53.1538C27.1426 51.7479 27.6439 50.0952 27.6439 48.4045"
                stroke="#343434"
                strokeWidth="3.267"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.0954 27.6441C17.4046 27.6441 15.7519 27.1428 14.3461 26.2035C12.9403 25.2641 11.8446 23.9291 11.1976 22.367C10.5506 20.805 10.3813 19.0861 10.7112 17.4279C11.041 15.7696 11.8552 14.2465 13.0507 13.0509C14.2462 11.8554 15.7694 11.0412 17.4277 10.7114C19.0859 10.3815 20.8048 10.5508 22.3668 11.1978C23.9289 11.8449 25.2639 12.9405 26.2033 14.3463C27.1426 15.7521 27.6439 17.4049 27.6439 19.0956"
                stroke="#343434"
                strokeWidth="3.267"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_353_13986">
                <rect width="67.5" height="67.5" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const LapTop = () => (
    <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_353_14010)">
            <path
                d="M53.55 12.6001H13.65C11.9103 12.6001 10.5 14.0104 10.5 15.7501V44.1001H56.7V15.7501C56.7 14.0104 55.2897 12.6001 53.55 12.6001Z"
                stroke="#343434"
                strokeWidth="3.15"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M56.2473 54.6001H10.9527C8.72414 54.6001 7.20031 52.3493 8.02796 50.2802L10.5 44.1001H56.7L59.172 50.2802C59.9997 52.3493 58.4759 54.6001 56.2473 54.6001Z"
                stroke="#343434"
                strokeWidth="3.15"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M31.5 16.8H35.7" stroke="#343434" strokeWidth="3.15" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_353_14010">
                <rect width="67.2" height="67.2" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const Lights = () => (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_353_14030)">
            <path
                d="M26.9887 51.7876C27.0704 53.3204 28.3309 54.5129 29.8659 54.5129H39.8783C41.4225 54.5129 42.687 53.3067 42.7613 51.7643C42.9988 46.833 43.5046 40.3485 46.6043 37.3193C49.5854 34.419 51.2506 30.5209 51.2415 26.4641C51.2415 17.8837 43.9058 10.9026 34.8882 10.9026C25.8424 10.9026 18.6596 17.6424 18.536 26.2455C18.5009 28.279 18.8877 30.2992 19.6741 32.1904C20.4605 34.0816 21.6312 35.8066 23.1191 37.2667C26.2168 40.3209 26.7254 46.8412 26.9887 51.7876Z"
                stroke="#343434"
                strokeWidth="2.90735"
            />
            <path
                d="M39.2493 55.603C39.2493 58.0116 37.2968 59.9641 34.8882 59.9641C32.4797 59.9641 30.5272 58.0116 30.5272 55.603"
                stroke="#343434"
                strokeWidth="2.90735"
            />
            <line x1="26.1662" y1="48.6982" x2="43.6103" y2="48.6982" stroke="#343434" strokeWidth="2.90735" />
            <path d="M13.0831 23.9856H8.72206" stroke="#343434" strokeWidth="2.90735" strokeLinecap="round" />
            <path d="M56.6934 23.3469H61.0544" stroke="#343434" strokeWidth="2.90735" strokeLinecap="round" />
            <path d="M14.6249 16.8052L11.5412 13.7215" stroke="#343434" strokeWidth="2.90735" strokeLinecap="round" />
            <path d="M55.1516 16.167L58.2353 13.0833" stroke="#343434" strokeWidth="2.90735" strokeLinecap="round" />
            <path d="M14.6249 30.5271L11.5412 33.6108" stroke="#343434" strokeWidth="2.90735" strokeLinecap="round" />
            <path d="M55.1516 29.8884L58.2353 32.9721" stroke="#343434" strokeWidth="2.90735" strokeLinecap="round" />
            <path d="M38.2805 33.6765V47.0027H32.5862V33.6765H38.2805Z" stroke="#343434" strokeWidth="1.93824" />
            <path
                d="M40.3393 29.3154C41.6103 29.3154 42.6409 30.3461 42.641 31.6172C42.641 32.8884 41.6104 33.9189 40.3393 33.9189H38.0375V31.6172L38.0502 31.3818C38.1682 30.2215 39.1478 29.3156 40.3393 29.3154Z"
                stroke="#343434"
                strokeWidth="1.93824"
            />
            <path
                d="M30.5275 29.3154C29.2564 29.3154 28.2259 30.3461 28.2257 31.6172C28.2257 32.8884 29.2563 33.9189 30.5275 33.9189H32.8292V31.6172L32.8165 31.3818C32.6985 30.2215 31.719 29.3156 30.5275 29.3154Z"
                stroke="#343434"
                strokeWidth="1.93824"
            />
        </g>
        <defs>
            <clipPath id="clip0_353_14030">
                <rect width="69.7765" height="69.7765" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const Speaker = () => (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M47.4453 8.21094H22.502C21.2432 8.21094 20.036 8.71097 19.146 9.60104C18.2559 10.4911 17.7559 11.6983 17.7559 12.957V57.043C17.7559 58.3017 18.2559 59.5089 19.146 60.399C20.036 61.289 21.2432 61.7891 22.502 61.7891H47.4453C48.7041 61.7891 49.9112 61.289 50.8013 60.399C51.6914 59.5089 52.1914 58.3017 52.1914 57.043V12.957C52.1914 11.6983 51.6914 10.4911 50.8013 9.60104C49.9112 8.71097 48.7041 8.21094 47.4453 8.21094ZM47.4453 58.625H22.502C22.0824 58.625 21.68 58.4583 21.3833 58.1616C21.0866 57.8649 20.9199 57.4626 20.9199 57.043V12.957C20.9199 12.5375 21.0866 12.1351 21.3833 11.8384C21.68 11.5417 22.0824 11.375 22.502 11.375H47.4453C47.8649 11.375 48.2673 11.5417 48.564 11.8384C48.8607 12.1351 49.0273 12.5375 49.0273 12.957V57.043C49.0273 57.4626 48.8607 57.8649 48.564 58.1616C48.2673 58.4583 47.8649 58.625 47.4453 58.625Z"
            fill="#343434"
        />
        <path
            d="M35 33.2639C30.0567 33.2639 26.0352 37.2854 26.0352 42.2288C26.0352 47.1721 30.0567 51.1936 35 51.1936C39.9433 51.1936 43.9648 47.1721 43.9648 42.2288C43.9648 37.2854 39.9433 33.2639 35 33.2639ZM35 48.0295C33.8527 48.0295 32.7312 47.6893 31.7773 47.0519C30.8233 46.4145 30.0798 45.5086 29.6408 44.4486C29.2017 43.3887 29.0869 42.2223 29.3107 41.0971C29.5345 39.9718 30.087 38.9382 30.8982 38.127C31.7095 37.3157 32.7431 36.7633 33.8683 36.5394C34.9936 36.3156 36.1599 36.4305 37.2199 36.8695C38.2798 37.3086 39.1858 38.0521 39.8232 39.006C40.4606 39.96 40.8008 41.0815 40.8008 42.2288C40.7991 43.7667 40.1874 45.2412 39.0999 46.3287C38.0124 47.4162 36.5379 48.0279 35 48.0295Z"
            fill="#343434"
        />
        <path
            d="M32.3633 22.5867C32.3633 23.286 32.6411 23.9566 33.1356 24.4511C33.63 24.9456 34.3007 25.2234 35 25.2234C35.6993 25.2234 36.37 24.9456 36.8644 24.4511C37.3589 23.9566 37.6367 23.286 37.6367 22.5867C37.6367 21.8874 37.3589 21.2167 36.8644 20.7222C36.37 20.2277 35.6993 19.95 35 19.95C34.3007 19.95 33.63 20.2277 33.1356 20.7222C32.6411 21.2167 32.3633 21.8874 32.3633 22.5867Z"
            fill="#343434"
        />
    </svg>
);

const Projector = () => (
    <svg width="69" height="69" viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_353_14064)">
            <path
                d="M56.0625 28.031H59.4375C61.1461 28.031 62.5312 29.4161 62.5312 31.1248V48.656C62.5312 50.3646 61.1461 51.7498 59.4375 51.7498H9.56247C7.85384 51.7498 6.46872 50.3646 6.46872 48.656V31.1248C6.46872 29.4161 7.85384 28.031 9.56247 28.031H34.5"
                stroke="#343434"
                strokeWidth="3.09375"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M21.5625 51.7498H12.9375V56.0623H21.5625V51.7498Z" stroke="#343434" strokeWidth="3.09375" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M56.0625 51.7498H47.4375V56.0623H56.0625V51.7498Z" stroke="#343434" strokeWidth="3.09375" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M45.2812 40.969C51.2357 40.969 56.0625 36.1422 56.0625 30.1877C56.0625 24.2333 51.2357 19.4065 45.2812 19.4065C39.3268 19.4065 34.5 24.2333 34.5 30.1877C34.5 36.1422 39.3268 40.969 45.2812 40.969Z"
                stroke="#343434"
                strokeWidth="3.09375"
                strokeMiterlimit="10"
            />
            <path d="M30.1875 17.2498L32.4505 19.5128" stroke="#343434" strokeWidth="3.09375" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M36.6562 12.9375L38.0052 15.8414" stroke="#343434" strokeWidth="3.09375" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M45.2812 10.7812V13.9837" stroke="#343434" strokeWidth="3.09375" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M60.4827 17.2498L58.2188 19.5128" stroke="#343434" strokeWidth="3.09375" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M53.0989 12.9375L51.75 15.8414" stroke="#343434" strokeWidth="3.09375" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_353_14064">
                <rect width="69" height="69" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const Fan = () => (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_353_14090)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.8882 6.5415C40.3074 6.5415 45.2136 8.73807 48.765 12.2894C52.3163 15.8408 54.5129 20.7469 54.5129 26.1661C54.5129 31.5853 52.3163 36.4915 48.765 40.0428C45.2136 43.5942 40.3074 45.7908 34.8882 45.7908C29.469 45.7908 24.5629 43.5942 21.0115 40.0428C17.4602 36.4915 15.2636 31.5853 15.2636 26.1661C15.2636 20.7469 17.4602 15.8408 21.0115 12.2894C24.5629 8.73807 29.469 6.5415 34.8882 6.5415Z"
                stroke="#343434"
                strokeWidth="2.90735"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.2045 21.5308C35.484 21.5308 36.6425 22.0494 37.481 22.8879C38.3195 23.7265 38.8382 24.8849 38.8382 26.1645C38.8382 27.4441 38.3195 28.6025 37.481 29.441C36.6425 30.2796 35.484 30.7982 34.2045 30.7982C32.9249 30.7982 31.7665 30.2796 30.9279 29.441C30.0894 28.6025 29.5707 27.4441 29.5707 26.1645C29.5707 24.8849 30.0894 23.7265 30.9279 22.8879C31.7665 22.0494 32.9249 21.5308 34.2045 21.5308Z"
                stroke="#343434"
                strokeWidth="2.90735"
            />
            <path
                d="M35.8139 20.847C37.1762 15.6081 38.6158 12.6459 39.9125 13.0112C41.8576 13.5591 44.7938 15.4273 44.4824 17.8627C44.2188 19.924 41.7713 22.8527 38.7892 25.3359"
                stroke="#343434"
                strokeWidth="2.90735"
            />
            <path
                d="M38.3097 28.9692C42.8713 31.8837 45.2436 34.1682 44.4955 35.2886C43.3734 36.9691 40.6892 39.1844 38.4693 38.1356C36.5903 37.2479 34.5612 34.0152 33.1212 30.4118"
                stroke="#343434"
                strokeWidth="2.90735"
            />
            <path
                d="M29.0293 27.9294C24.0255 29.9943 20.7934 30.6272 20.3048 29.3718C19.5718 27.4887 19.2967 24.0194 21.4291 22.8025C23.234 21.7725 27.0459 21.9645 30.8237 22.8517"
                stroke="#343434"
                strokeWidth="2.90735"
            />
            <path d="M31.6175 44.7004L29.5395 55.8983" stroke="#343434" strokeWidth="2.90735" />
            <path d="M38.159 44.7004L40.2964 55.7895" stroke="#343434" strokeWidth="2.90735" />
            <path d="M47.9713 50.1519V54.2975" stroke="#343434" strokeWidth="2.90735" strokeLinecap="round" />
            <rect x="14.5368" y="55.9666" width="40.7029" height="5.81471" rx="2.90735" stroke="#343434" strokeWidth="2.90735" />
        </g>
        <defs>
            <clipPath id="clip0_353_14090">
                <rect width="69.7765" height="69.7765" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const ElectricBlanket = () => (
    <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="6.3" y="16.8" width="44.1" height="29.4" rx="3.15" stroke="#343434" strokeWidth="3.15" />
        <path
            d="M12.6 39.9001V25.2001C12.6 24.0403 13.5402 23.1001 14.7 23.1001H16.8C17.9598 23.1001 18.9 24.0403 18.9 25.2001V37.8001C18.9 38.9599 19.8402 39.9001 21 39.9001H23.1C24.2598 39.9001 25.2 38.9599 25.2 37.8001V25.2001C25.2 24.0403 26.1402 23.1001 27.3 23.1001H29.4C30.5598 23.1001 31.5 24.0403 31.5 25.2001V37.8001C31.5 38.9599 32.4402 39.9001 33.6 39.9001H35.7C36.8598 39.9001 37.8 38.9599 37.8 37.8001V25.2001C37.8 24.0403 38.7402 23.1001 39.9 23.1001H42C43.1598 23.1001 44.1 24.0403 44.1 25.2001V39.9001"
            stroke="#343434"
            strokeWidth="3.15"
            strokeLinecap="round"
        />
        <path
            d="M14.7 44.9401V50.4001C14.7 51.5599 15.6402 52.5001 16.8 52.5001H55.65C56.8098 52.5001 57.75 51.5599 57.75 50.4001V33.6001"
            stroke="#343434"
            strokeWidth="3.15"
        />
        <rect x="53.55" y="17.85" width="8.4" height="14.7" rx="1.05" fill="#343434" stroke="#343434" strokeWidth="2.1" />
        <path
            d="M59.325 22.575C59.325 23.4448 58.6199 24.15 57.75 24.15C56.8802 24.15 56.175 23.4448 56.175 22.575C56.175 21.7052 56.8802 21 57.75 21C58.6199 21 59.325 21.7052 59.325 22.575Z"
            fill="white"
        />
        <circle cx="57.75" cy="28.35" r="1.05" fill="white" />
    </svg>
);

const Fridge = () => (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_353_14139)">
            <path
                d="M49.425 6.5415H20.3515C18.7458 6.5415 17.4441 7.84317 17.4441 9.44886V60.3275C17.4441 61.9332 18.7458 63.2349 20.3515 63.2349H49.425C51.0307 63.2349 52.3323 61.9332 52.3323 60.3275V9.44886C52.3323 7.84317 51.0307 6.5415 49.425 6.5415Z"
                stroke="#343434"
                strokeWidth="2.90735"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M17.4441 30.5271L52.3324 30.5271" stroke="#343434" strokeWidth="2.90735" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M23.9857 17.4441L23.9857 23.9856" stroke="#343434" strokeWidth="2.90735" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M23.9857 37.0688L23.9857 43.6104" stroke="#343434" strokeWidth="2.90735" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_353_14139">
                <rect width="69.7765" height="69.7765" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const CoffeeMaker = () => (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_353_14160)">
            <path
                d="M28.3467 58.8739V12.8408C28.3467 11.7704 27.4789 10.9026 26.4085 10.9026C17.8448 10.9026 10.9026 17.8448 10.9026 26.4085V55.9666C10.9026 57.5722 12.2042 58.8739 13.8099 58.8739H28.3467Z"
                stroke="#343434"
                strokeWidth="2.90735"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M58.8739 45.064C59.6767 45.064 60.3276 44.4132 60.3276 43.6104C60.3276 42.8075 59.6767 42.1567 58.8739 42.1567V45.064ZM52.3324 43.6104V45.064H58.8739V43.6104V42.1567H52.3324V43.6104Z"
                fill="#343434"
            />
            <path
                d="M52.3324 23.9856L52.3324 20.8359C52.3324 16.5541 48.8612 13.083 44.5794 13.083L28.3467 13.083L28.3467 23.9856L52.3324 23.9856Z"
                stroke="#343434"
                strokeWidth="2.90735"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M47.9713 30.5271L47.9713 23.9856L39.2493 23.9856L39.2493 30.5271L47.9713 30.5271Z"
                stroke="#343434"
                strokeWidth="2.90735"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M52.3324 44.7005L52.3324 41.4297L37.0688 41.4297L37.0688 44.7005C37.0688 48.9154 40.4856 52.3323 44.7006 52.3323C48.9155 52.3323 52.3324 48.9154 52.3324 44.7005Z"
                stroke="#343434"
                strokeWidth="2.90735"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.3467 58.8738L57.5656 58.8738C58.2882 58.8738 58.8739 58.2881 58.8739 57.5655C58.8739 54.6753 56.5309 52.3323 53.6407 52.3323L28.3467 52.3323L28.3467 58.8738Z"
                stroke="#343434"
                strokeWidth="2.90735"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_353_14160">
                <rect width="69.7765" height="69.7765" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const ElectricGrill = () => (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_353_14183)">
            <path
                d="M53.786 8.72217H15.9904C14.3848 8.72217 13.0831 10.0238 13.0831 11.6295V58.1472C13.0831 59.7528 14.3848 61.0545 15.9904 61.0545H53.786C55.3917 61.0545 56.6934 59.7529 56.6934 58.1472V11.6295C56.6934 10.0238 55.3917 8.72217 53.786 8.72217Z"
                stroke="#343434"
                strokeWidth="2.90735"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M19.6246 15.2637H26.1662" stroke="#343434" strokeWidth="2.90735" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="47.9713" cy="15.2635" r="2.18051" fill="#343434" />
            <path
                d="M47.2445 28.3467H22.532C20.9263 28.3467 19.6246 29.6483 19.6246 31.254V51.6055C19.6246 53.2112 20.9263 54.5129 22.532 54.5129H47.2445C48.8502 54.5129 50.1518 53.2112 50.1518 51.6055V31.254C50.1518 29.6483 48.8502 28.3467 47.2445 28.3467Z"
                stroke="#343434"
                strokeWidth="2.90735"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.5647 34.8882L30.3132 37.3859C31.0675 38.4636 30.9394 39.9273 30.0092 40.8575V40.8575C29.0553 41.8114 28.9479 43.3216 29.7574 44.4009L31.6175 46.881"
                stroke="#343434"
                strokeWidth="2.90735"
                strokeLinecap="round"
            />
            <path
                d="M37.2868 34.8882L39.0352 37.3859C39.7896 38.4636 39.6614 39.9273 38.7313 40.8575V40.8575C37.7773 41.8114 37.67 43.3216 38.4795 44.4009L40.3395 46.881"
                stroke="#343434"
                strokeWidth="2.90735"
                strokeLinecap="round"
            />
            <path d="M13.0831 21.8052H56.6934" stroke="#343434" strokeWidth="2.90735" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_353_14183">
                <rect width="69.7765" height="69.7765" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const Microwave = () => (
    <svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_353_14207)">
            <path
                d="M53.9 61.6001H16.5C14.6775 61.6001 13.2 60.1226 13.2 58.3001V12.1001C13.2 10.2776 14.6775 8.80009 16.5 8.80009H53.9C55.7226 8.80009 57.2 10.2776 57.2 12.1001V58.3001C57.2 60.1226 55.7226 61.6001 53.9 61.6001Z"
                stroke="#343434"
                strokeWidth="3.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M13.2 48.3999H57.2" stroke="#343434" strokeWidth="3.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M44 55H50.6" stroke="#343434" strokeWidth="3.3" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="2.2" cy="2.2" r="2.2" transform="matrix(1 0 0 -1 17.6 57.2)" fill="#343434" />
            <circle cx="2.2" cy="2.2" r="2.2" transform="matrix(1 0 0 -1 24.2 57.2)" fill="#343434" />
            <circle cx="2.2" cy="2.2" r="2.2" transform="matrix(1 0 0 -1 30.8 57.2)" fill="#343434" />
            <circle cx="13.2" cy="13.2" r="13.2" transform="matrix(1 0 0 -1 22 41.8)" stroke="#343434" strokeWidth="3.3" />
        </g>
        <defs>
            <clipPath id="clip0_353_14207">
                <rect width="70.4" height="70.4" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const ElectricKettle = () => (
    <svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_353_14231)">
            <path
                d="M48.4 24.2001C48.7768 24.2301 51.3394 24.1621 51.7 24.2001C58.3 24.2001 61.6 29.6667 61.6 34.1001C61.6 36.3001 60.5 40.7001 57.0545 43.2822C56.6764 43.5258 54.3099 43.7651 53.9 44.0001"
                stroke="#343434"
                strokeWidth="3.3"
            />
            <path
                d="M21.497 24.2C19.5415 24.2 16.6081 24.2 12.697 24.2C13.3063 25.5374 16.0729 31.5271 17.6001 31.9"
                stroke="#343434"
                strokeWidth="3.3"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.2 6.6001C35.8075 6.6001 36.3576 6.84636 36.7557 7.24454C37.1538 7.64264 37.4 8.19261 37.4 8.8001C37.4 9.40759 37.1538 9.95755 36.7557 10.3557C36.3576 10.7538 35.8075 11.0001 35.2 11.0001C34.5925 11.0001 34.0424 10.7538 33.6443 10.3557C33.2462 9.95755 33 9.40759 33 8.8001C33 8.19261 33.2462 7.64264 33.6443 7.24454C34.0424 6.84636 34.5925 6.6001 35.2 6.6001Z"
                stroke="#343434"
                strokeWidth="2.64"
            />
            <path
                d="M54.6713 57.0504C54.6981 56.7782 54.7233 56.505 54.7469 56.2308C54.9135 54.2948 55 52.3086 55 50.2846C55 40.6667 53.0452 31.9039 49.839 25.3141C46.2177 17.871 41.0001 13.2 35.2 13.2C29.3761 13.2 24.1395 17.9094 20.5165 25.4059C17.3368 31.9852 15.4 40.7113 15.4 50.2846C15.4 52.3488 15.4901 54.3735 15.6632 56.3458C15.6883 56.6316 15.7151 56.9164 15.7437 57.2"
                stroke="#343434"
                strokeWidth="3.3"
            />
            <path d="M22 24.2H50.6" stroke="#343434" strokeWidth="3.3" />
            <path d="M33 50.6001H37.4" stroke="#343434" strokeWidth="3.3" strokeLinecap="round" />
            <rect x="12.65" y="56.65" width="45.1" height="5.5" rx="2.75" stroke="#343434" strokeWidth="3.3" />
        </g>
        <defs>
            <clipPath id="clip0_353_14231">
                <rect width="70.4" height="70.4" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const StarLink = () => (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_383_14393)">
            <path
                d="M30.592 54.7287H26.1149C21.9109 54.7287 19.5107 49.9282 22.0402 46.5722L31.5837 33.8595C32.9707 32.0126 35.7374 32.0126 37.1244 33.8595L46.6679 46.5722C49.1903 49.9354 46.79 54.7287 42.5932 54.7287H37.764"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M31.0447 51.696C29.4637 50.8049 28.4288 49.2958 28.4288 47.5854C28.4288 44.8474 31.0806 42.6268 34.3504 42.6268C37.6202 42.6268 40.2719 44.8474 40.2719 47.5854C40.2719 49.2958 39.2371 50.8049 37.6633 51.696"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M31.1669 47.1257C31.1669 45.9112 32.5898 44.9266 34.3432 44.9266C36.0967 44.9266 37.5268 45.9112 37.5268 47.1257"
                stroke="#343434"
                strokeWidth="2.40303"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M31.1669 47.5784V60.6719" stroke="#343434" strokeWidth="2.40303" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M37.5267 47.5784V60.6719" stroke="#343434" strokeWidth="2.40303" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M37.5268 47.1255C37.5268 47.995 36.1039 48.6921 34.3504 48.6921C32.597 48.6921 31.1669 47.9879 31.1669 47.1255"
                stroke="#343434"
                strokeWidth="2.40303"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M37.5268 50.6614C37.5268 51.5309 36.1039 52.228 34.3504 52.228C32.597 52.228 31.1669 51.5237 31.1669 50.6614"
                stroke="#343434"
                strokeWidth="2.40303"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M37.5268 54.2043C37.5268 55.0739 36.1039 55.771 34.3504 55.771C32.597 55.771 31.1669 55.0667 31.1669 54.2043"
                stroke="#343434"
                strokeWidth="2.40303"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M37.5268 57.7472C37.5268 58.6167 36.1039 59.3138 34.3504 59.3138C32.597 59.3138 31.1669 58.6096 31.1669 57.7472"
                stroke="#343434"
                strokeWidth="2.40303"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M30.6637 58.8679C30.6637 58.8679 28.1628 55.476 25.2164 54.6495"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.8398 28.772C21.0411 28.6929 25.4463 25.4806 29.4203 29.1529"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M27.351 39.5586C20.9838 37.5967 17.1032 33.0478 15.8528 31.3805C15.4791 30.8775 15.4072 30.1804 15.7666 29.663C15.9462 29.4043 16.2121 29.1959 16.6145 29.1743"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.0772 51.4518C18.8853 48.4623 16.6935 44.5745 16.6935 40.2483V32.4727"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.4347 40.9454C14.3794 40.5573 12.7769 37.0432 12.7769 34.8298C12.7769 32.4798 14.5806 32.4727 16.8084 32.4727"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M37.9436 58.8679C37.9436 58.8679 40.4445 55.476 43.3909 54.6495"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M47.7673 28.772C47.5661 28.6929 43.1608 25.4806 39.1868 29.1529"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M41.5222 39.4725C47.7312 37.4675 51.5184 33.0191 52.7545 31.3734C53.1282 30.8704 53.2 30.1733 52.8407 29.6559C52.6611 29.3972 52.3952 29.1888 51.9927 29.1672"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M51.9138 29.1744V25.4518C51.9138 16.3252 44.519 8.93042 35.3996 8.93042H32.5394H36.0607H33.2077C24.0882 8.93042 16.6935 16.3252 16.6935 25.4518V29.1744"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M47.5302 51.4518C49.722 48.4695 51.9138 44.5745 51.9138 40.2483V32.4727"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M52.2155 40.9382C54.2493 40.5142 55.8374 37.036 55.8374 34.8298C55.8374 32.4798 54.0337 32.4727 51.8059 32.4727"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.8008 19.0488H26.8047C28.0479 19.0488 29.248 19.5447 30.1248 20.4214C31.0015 21.2982 32.2016 21.794 33.4449 21.794H35.2199"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M44.8066 19.0488H41.8027C40.5594 19.0488 39.3593 19.5447 38.4826 20.4214C37.5987 21.3053 36.4057 21.794 35.1625 21.794H33.3875"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M41.0049 31.2441C41.0049 31.2441 44.0806 32.2286 46.1216 30.8417"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M27.8321 31.2441C27.8321 31.2441 24.7564 32.2286 22.7155 30.8417"
                stroke="#343434"
                strokeWidth="2.88364"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_383_14393">
                <rect width="60.7081" height="60.7081" fill="white" transform="translate(4.61499 4.44702)" />
            </clipPath>
        </defs>
    </svg>
);

const CPAP = () => (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_383_14385)">
            <path
                d="M22.6293 63.1855C22.816 63.2349 23.0069 63.2602 23.1926 63.2602C23.9569 63.2602 24.6686 62.8584 24.918 62.2243L27.5581 55.5489H43.2411L45.8822 62.2243C46.1931 63.0128 47.2199 63.4419 48.1709 63.1855C49.124 62.928 49.6439 62.08 49.3319 61.2935L37.9609 32.5333C39.547 31.6378 40.6192 29.9396 40.6192 27.9881C40.6192 25.1067 38.282 22.7695 35.4006 22.7695C32.5192 22.7695 30.182 25.1067 30.182 27.9881C30.182 29.9396 31.2542 31.6378 32.8413 32.5333L21.4682 61.2935C21.1563 62.08 21.6762 62.928 22.6303 63.1855H22.6293ZM32.7878 27.8952C32.7878 26.4525 33.9569 25.2834 35.3996 25.2834C36.8423 25.2834 38.0114 26.4525 38.0114 27.8952C38.0114 29.3379 36.8423 30.507 35.3996 30.507C33.9569 30.507 32.7878 29.3379 32.7878 27.8952ZM35.4006 35.7165L38.5465 43.6711H32.2557L35.4016 35.7165H35.4006ZM31.0745 46.6554L31.2593 46.6716H39.5419L39.7267 46.6554L42.0548 52.5474H28.7454L31.0735 46.6554H31.0745Z"
                fill="#343434"
            />
            <path
                d="M47.3048 42.1565C46.4881 42.8491 45.6067 43.4741 44.6819 44.0152C44.484 44.1293 44.3972 44.3696 44.475 44.5836L45.2574 46.7502C45.3038 46.8824 45.4068 46.9854 45.537 47.0339C45.6673 47.0823 45.8137 47.0722 45.9358 47.0036C46.8929 46.4685 47.8308 45.8436 48.7193 45.15C54.0146 41.0026 57.0494 34.7885 57.0494 28.099C57.0504 16.1606 47.3382 6.44934 35.3997 6.44934C34.582 6.44934 33.7511 6.49578 32.9273 6.58665C22.9656 7.69619 14.9535 15.7396 13.8763 25.7083C13.0646 33.2277 16.1307 40.4958 22.0782 45.15C22.9656 45.8456 23.9025 46.4685 24.8637 47.0056C24.9353 47.045 25.0141 47.0662 25.0938 47.0662L25.2604 47.0359C25.3907 46.9864 25.4936 46.8834 25.5411 46.7522L26.3225 44.5856C26.4002 44.3716 26.3134 44.1313 26.1155 44.0172C25.1908 43.4751 24.3094 42.8511 23.4926 42.1586C19.1877 38.5049 16.8112 33.1843 16.9727 27.5609C17.2473 17.9849 24.9555 10.1374 34.5194 9.69114C45.0918 9.1712 53.8308 17.6467 53.8308 28.103C53.8308 33.5155 51.4522 38.6391 47.3028 42.1586L47.3048 42.1565Z"
                fill="#343434"
            />
            <path
                d="M41.6053 35.69C41.4498 35.8172 41.3913 36.0282 41.4589 36.217L42.2666 38.4522C42.3161 38.5925 42.4302 38.7006 42.5715 38.745L42.7128 38.7662C42.8108 38.7662 42.9077 38.7359 42.9895 38.6773C43.9698 37.9737 44.8481 37.1367 45.5983 36.1938C47.4519 33.8666 48.4312 31.065 48.4312 28.0968C48.4312 21.9626 44.0758 16.6016 38.0748 15.3437C36.3201 14.9732 34.4827 14.9732 32.727 15.3437C26.727 16.6016 22.3706 21.9636 22.3706 28.0968C22.3706 31.066 23.3509 33.8646 25.2045 36.1938C25.9547 37.1357 26.831 37.9727 27.8113 38.6773C27.9314 38.7632 28.0879 38.7884 28.2282 38.746C28.3716 38.7016 28.4847 38.5935 28.5352 38.4532L29.3408 36.218C29.4095 36.0292 29.3509 35.8182 29.1964 35.691C28.2878 34.9439 27.5256 34.0524 26.9309 33.0378C26.0526 31.5395 25.5882 29.8313 25.5882 28.0968C25.5882 23.9928 28.1808 20.2887 32.0395 18.8783C34.1939 18.0908 36.6068 18.0908 38.7593 18.8783C42.6179 20.2887 45.2106 23.9939 45.2106 28.0968C45.2106 29.8313 44.7472 31.5405 43.8698 33.0388C43.2742 34.0554 42.5119 34.9469 41.6043 35.69H41.6053Z"
                fill="#343434"
            />
            <path
                d="M32.7872 27.8873C32.7872 29.33 33.9563 30.4991 35.399 30.4991C36.8417 30.4991 38.0109 29.33 38.0109 27.8873C38.0109 26.4446 36.8417 25.2755 35.399 25.2755C33.9563 25.2755 32.7872 26.4446 32.7872 27.8873Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_383_14385">
                <rect width="43.3024" height="56.8097" fill="white" transform="translate(13.7485 6.44702)" />
            </clipPath>
        </defs>
    </svg>
);

export {
    Phone,
    Camera,
    Drone,
    LapTop,
    Lights,
    Speaker,
    Projector,
    Fan,
    ElectricBlanket,
    Fridge,
    CoffeeMaker,
    ElectricGrill,
    Microwave,
    ElectricKettle,
    StarLink,
    CPAP,
};
